import { createReducer } from '../utils';
import {
  SHOW_FLOATING_BUTTON,
  HIDE_FLOATING_BUTTON,
  OPEN_MENU,
  CLOSE_MENU,
} from '../constants';

const defaultState = {
  visible: false,
  open: false,
};

// reducer

export const reducer = createReducer(defaultState, {
  [SHOW_FLOATING_BUTTON]: handleShowFloatingButton,
  [HIDE_FLOATING_BUTTON]: handleHideFloatingButton,
  [OPEN_MENU]: handleOpenMenu,
  [CLOSE_MENU]: handleCloseMenu,
});

function handleShowFloatingButton(state, action) {
  return {
    ...state,
    visible: true,
  };
}

function handleHideFloatingButton(state, action) {
  return {
    ...state,
    visible: false,
  };
}

function handleOpenMenu(state, action) {
  return {
    ...state,
    open: true,
  };
}

function handleCloseMenu(state, action) {
  return {
    ...state,
    open: false,
  };
}

// actions

export function showFloatingButton() {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: SHOW_FLOATING_BUTTON });
    } catch (error) {
      console.log(error);
    }
  };
}

export function hideFloatingButton() {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: HIDE_FLOATING_BUTTON });
    } catch (error) {
      console.log(error);
    }
  };
}

export function openMenu() {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: OPEN_MENU });
    } catch (error) {
      console.log(error);
    }
  };
}

export function closeMenu() {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: CLOSE_MENU });
    } catch (error) {
      console.log(error);
    }
  };
}
